import { defineStore } from "pinia";
import fallbackLogo from '@/assets/duallo-logo-white.png';

export const useOrganizationStore = defineStore("organization", {
  state: () => ({
    organizationId: sessionStorage.getItem("organizationId") || null,
    active: sessionStorage.getItem("active") || null,
    authZeroOrgId: sessionStorage.getItem("authZeroOrgId") || null,
    organizationLogoUrl: sessionStorage.getItem("organizationLogoUrl") || null
  }),
  actions: {
    setOrganizationId(id) {
      this.organizationId = id;
      sessionStorage.setItem("organizationId", id);
    },
    setOrganizationSubscriptionActive(isActive){
      this.active = isActive;
      sessionStorage.setItem("active", isActive);
    },
    setAuthZeroOrgId(id){
      this.authZeroOrgId = id;
      sessionStorage.setItem("authZeroOrgId", id);
    },
    setOrganizationLogoUrl(url){
      this.organizationLogoUrl = url ?? fallbackLogo;
      sessionStorage.setItem("organizationLogoUrl", url);
    },
    clearAuthZeroOrgId(){
      this.authZeroOrgId = null;
      sessionStorage.removeItem("authZeroOrgId");
    },
    clearOrganizationId() {
      this.organizationId = null;
      sessionStorage.removeItem("organizationId");
    },
    clearActiveSubscription(){
      this.isActive = null;
      sessionStorage.removeItem("active");
    },
    clearOrganizationLogoUrl(){
      this.organizationLogoUrl = null;
      sessionStorage.removeItem("organizationLogoUrl");
    },
    reset(){
      this.clearActiveSubscription();
      this.clearOrganizationId();
      this.clearAuthZeroOrgId();
      this.clearOrganizationLogoUrl();
    }
  }
});
